import { render } from "./IntegratorsListView.vue?vue&type=template&id=65f809f0"
import script from "./IntegratorsListView.vue?vue&type=script&lang=js"
export * from "./IntegratorsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__